import styled from "styled-components";
import { Palette } from "../../../shared/theme/palette";

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 1128px;
  height: 72px;
  padding: 20px 32px;
  border-radius: 8px;
  background:  ${Palette.white};
  box-shadow: 0px 4px 22px 0px #00000014;
  margin-bottom: 10px;
`;

export const FilterContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
`;

export const ButtonText = styled.span<{ primaryColor: string }>`
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: ${(props) => props.primaryColor};
`;
export const Row = styled.div`
  display: flex;
  gap: 30px;
  padding: 50px;
`;